/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane
} from 'mdb-react-ui-kit';
import "../style/css/tabsnav.css"

interface TabsnavProps {
  tab1: string;
  tab2: string;
  path1: string;
  path2: string;
  additionalPathsForTab2?: string[];
  additionalPathsForTab22?: string[];
}

const TabsNav: React.FC<TabsnavProps> = ({ tab1, tab2, path1, path2, additionalPathsForTab2 = [], additionalPathsForTab22 = [] }) => {

  const [basicActive, setBasicActive] = useState('tab1');
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    if (
      pathname === path2 ||
      additionalPathsForTab2.includes(pathname) ||
      additionalPathsForTab22.some(path => {
        const isPathWithId = path.includes(':id');
        if (isPathWithId) {
          const pathWithoutId = path.replace('/:id', '');
          return pathname.startsWith(pathWithoutId);
        }
        return false;
      })
    ) {
      setBasicActive('tab2');
    } else {
      setBasicActive('tab1');
    }
  }, [location.pathname, path2, additionalPathsForTab2, additionalPathsForTab22]);

  const handleBasicClick = (value: string, path: string) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
    window.location.href = path; // Rediriger vers le chemin correspondant
  };

  return (
    <>

      <MDBTabs className='mb-3' id="tabsnav">

        <MDBTabsItem>
          
          <MDBTabsLink 
            onClick={() => handleBasicClick('tab1', path1)} 
            active={basicActive === 'tab1'} 
            id={basicActive === 'tab1' ? 'selected-tab' : 'nonselected'}>
            {tab1}
          </MDBTabsLink>

        </MDBTabsItem>
        
        <MDBTabsItem>

          <MDBTabsLink 
            onClick={() => handleBasicClick('tab2', path2)} 
            active={basicActive === 'tab2'} 
            id={basicActive === 'tab2' ? 'selected-tab' : 'nonselected'}>
            {tab2}
          </MDBTabsLink>

        </MDBTabsItem>

      </MDBTabs>

      <MDBTabsContent>

        <MDBTabsPane show={basicActive === 'tab1' ? "true" : "false"}></MDBTabsPane>

        <MDBTabsPane show={basicActive === 'tab2' ? "true" : "false"}></MDBTabsPane>

      </MDBTabsContent>
      
    </>
  );
}

export default TabsNav;
